import { AttachMoney } from '@mui/icons-material';
import { Button, Card, CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Select, TextField } from '@mui/material';
import React, { useState, useEffect } from "react";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import axios from 'axios';
import { bankaccount, deleteAccount, Ownerpayment, payment } from '../../../components/Apis';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { Container, MenuItem, FormControl, InputLabel } from "@mui/material";
import EditPayment from './EditPayment';


const rows = [
  {
    unitName: "Villa Sahel",
    ownerName: "Mariam Ahmed",
    ownerImage: "https://via.placeholder.com/40", // صورة placeholder
    status: "Approved",
    date: "12/3/2024",
    Amount: "3000$",
    Servicesfee: "1000$"
  },
  {
    unitName: "Villa Sahel",
    ownerName: "Mariam Ahmed",
    ownerImage: "https://via.placeholder.com/40",
    status: "Pending",
    date: "12/3/2024",
    Amount: "3000$",
    Servicesfee: "1000$"
  },
  {
    unitName: "Villa Sahel",
    ownerName: "Mariam Ahmed",
    ownerImage: "https://via.placeholder.com/40",
    status: "Canceled",
    date: "12/3/2024",
    Amount: "3000$",
    Servicesfee: "1000$"

  },
];
const getStatusColor = (status) => {
  switch (status) {
    case "Approved":
      return { color: "green", label: "✔ Approved" };
    case "Pending":
      return { color: "orange", label: "⏳ Pending" };
    case "Canceled":
      return { color: "red", label: "✖ Canceled" };
    default:
      return { color: "black", label: status };
  }
};
const Payment = () => {
  const [selectedButton, setSelectedButton] = useState(null);
  const token = localStorage.getItem("token") || ""; // Get token from localStorage
  const [banks, setBanks] = useState([])
  const [bankAccount, setBankAccount] = useState([])
  const [bankID, setBankID] = useState()
  const [payments, setPayments] = useState([])
  console.log("Payments details", payments)
  const [render, setRender] = useState(false)
  const RenderFun = () => { setRender(!render) }
  const [formData, setFormData] = useState({
    account_number: "",
    bank_id: "",
  });
  console.log("Bank Account", bankAccount.payment_number)
  // console.log("payments", payments)
  const containerStyle = {
    display: 'flex',
    flexDirection: 'row', // ترتيب الأزرار جنب بعض
    alignItems: 'center', // محاذاة الأزرار بشكل مركزي
    padding: '20px', // مسافة داخلية للحاوية
    borderRadius: '20px', // حواف خلفية دائرية
    backgroundColor: 'var(--pri-col)1F', // لون الخلفية
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // ظل للخلفية
  };

  const buttonStyle = (isSelected) => ({
    display: 'inline-block',
    padding: '10px 40px', // حجم الزر
    backgroundColor: isSelected ? '#a0553a' : 'var(--pri-col)1F', // لون عند التحديد وغير التحديد
    color: isSelected ? 'white' : '#b36b59',
    borderRadius: '15px', // حواف دائرية
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    textAlign: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    border: 'none', // إزالة الإطار
    margin: '0 10px', // مسافة بين الأزرار
    transition: 'background-color 0.2s, transform 0.2s',
  });

  const handleClick = (button) => {
    setSelectedButton(button);
  };


  const styles = {
    card: {
      backgroundColor: "#fff",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      padding: "24px",
      width: "50%",
      maxWidth: "100%",
      margin: "0 auto",
    },
    cardTitle: {
      fontSize: "18px",
      marginBottom: "16px",
    },
    formRow: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "16px",
      gap: "12px",
    },
    formGroup: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    label: {
      fontSize: "14px",
      marginBottom: "8px",
    },
    input: {
      padding: "10px",
      border: "1px solid #e5e5e5",
      borderRadius: "8px",
      fontSize: "14px",
      backgroundColor: "#f7f7f7",
    },
    button: {
      backgroundColor: "#b26a48",
      color: "#fff",
      padding: "12px",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "16px",
      width: "100%",
      transition: "background-color 0.3s ease",
    },
    buttonHover: {
      backgroundColor: "#914e33",
    },
  };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axios.get("https://app.baskeg.com/api/v1/banks", {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response.data.data)
        setBanks(response.data.data);
      } catch (error) {
        // console.error("Error fetching units:", error);
      }
    };
    if (token) fetchBanks();
  }, [token]);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await Ownerpayment()
        console.log("Payments details", response)
        setPayments(response);
      } catch (error) {
        // console.error("Error fetching units:", error);
      }
    };
    if (token) fetchPayments();
  }, [token]);

  useEffect(() => {
    const fetchBankAccount = async () => {
      try {
        const response = await bankaccount()
        console.log("Bank Account kldfjsjfkk", response)
        setBankAccount(response);
      } catch (error) {
        // console.error("Error fetching Bank Account:", error);
      }
    };
    if (token) fetchBankAccount();
  }, [token, render]);


  //------------------------ Add Bank Account ------------------------------------------------------------
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const handleUnitChange = (event) => {
    setFormData({ ...formData, account_number: event.target.value });
  };

  const handleBankChange = (event) => {
    setFormData({ ...formData, bank_id: event.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData)
    try {
      const response = await axios.post(
        "https://app.baskeg.com/api/v1/owners/bank-accounts",
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("Account Response:", response.data);
      window.location.reload();
    } catch (error) {
      // console.error("Error submitting request:", error);
    }
  };
  //-------------------------------------------- Delete Account----------------
  const deleteaccount = async (id) => {
    console.log("bankAccountttttttttttt", id)
    try {
      const response = await deleteAccount(id)
      console.log("Account Response:", response.data);
      window.location.reload();
    } catch (error) {
      // console.error("Error submitting request:", error);
    }
  };


  // ---------------------------------- Edit bank account ----------------------------------
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);


  return (
    <div style={{ 
      minHeight: "100vh", 
      backgroundColor: "var(--seco-col)", 
      position: "relative",
      padding: "0 1rem", // Add padding for small screens
      paddingTop: "4rem"
    }}>
      <p style={{ 
        textAlign: "left", 
        fontSize: { xs: "20px", md: "24px" }, // Responsive font size
        fontWeight: "bold", 
        padding: "20px",
        borderBottom: "1px solid #E1D7D2",
        marginLeft: { xs: "0", md: "1.5rem" } // Responsive margin
      }}>
        Payment
      </p>

      <Grid item xs={12} sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", md: "row-reverse" }, // Stack on mobile
        justifyContent: "flex-start", 
        alignItems: { xs: "center", md: "flex-start" },
        gap: { xs: "2rem", md: "20rem" }
      }}>
        <h4 style={{ 
          textAlign: "left", 
          marginLeft: { xs: "0", md: "3rem" }, 
          marginTop: "0px", 
          fontSize: "17px" 
        }}>
          Bank Details
        </h4>
        <div style={{ 
          width: { xs: "100%", md: "30%" }, // Full width on mobile
          height: "auto", 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "flex-start", 
          gap: ".5rem" 
        }}>
          {bankAccount.map((bank) => {
            return (
              <Card elevation={3} sx={{ width: "100%", borderRadius: 2, display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: 1 }}>
                <Typography
                  onClick={() => { deleteaccount(bank.id) }}
                  component="span"
                  sx={{
                    color: "var(--pri-col)",
                    textDecoration: "none",
                    cursor: "pointer",
                    fontSize: "0.875rem",
                    alignSelf: "center"
                  }}
                >
                  Delete
                </Typography>
                <Typography
                  onClick={() => { handleOpen2(); setBankID(bank.id) }}
                  component="span"
                  sx={{
                    color: "var(--pri-col)",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "0.875rem",
                    alignSelf: "center",
                    marginInline:"20px"
                  }}
                >
                  Edit
                </Typography>

                <CardContent style={{ display: "flex", alignItems: "center", justifyContent: "left", padding: "0px" }}>



                  <div>
                    <Typography variant="body1" color="textSecondary" style={{ textAlign: "left" }}>
                      {bank.bank_name}
                    </Typography>
                    <Typography variant="body1" style={{ textAlign: "left", fontWeight: 800 }}>
                      {bank.account_number}
                    </Typography>
                  </div>


                  <CreditCardIcon
                    style={{
                      color: "var(--pri-col)",
                      padding: "5px",
                      marginRight: "10px",
                      fontSize: "40px", // Adjust this to your desired size

                    }}
                  />
                </CardContent>
              </Card>
            )
          })}

          <Link
            onClick={handleOpen}
            // to="/"
            style={{
              width: "100%",
              alignSelf: "flex-start", // Aligns the element itself to the start
              textAlign: "left", // Ensures text inside stays aligned left
              color: "var(--pri-col)",
              textDecoration: "none",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "400",
            }}
          >
            Add Bank Account <span style={{ fontSize: "1.5rem", fontWeight: "400", marginLeft: "10px" }}>+</span>
          </Link>

          {/* -------------------------------------- add bank account popup -------------------------------------- */}
          <Modal
            open={open}
            onClose={handleClose}
          // aria-labelledby="modal-modal-title"
          // aria-describedby="modal-modal-description"
          >
            <Box sx={{
              ...style,
              width: { xs: "90%", sm: 400 }, // Responsive width
              maxWidth: "100%",
              maxHeight: "90vh",
              overflow: "auto"
            }}>
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px", direction: "ltr" }}>
                <TextField
                  name="account_number"
                  label="Account Number"
                  type="text"
                  value={formData.account_number || ''}
                  onChange={handleUnitChange}
                  // fullWidth
                  sx={{ width: '100%', direction: "ltr" }}
                  margin="normal"
                />
                <FormControl fullWidth sx={{ border: "none", boxShadow: "none" }}>
                  <InputLabel shrink={false} sx={{
                    position: 'relative',
                    transform: 'none',
                    marginBottom: '5px'
                  }}>Select Bank</InputLabel>
                  <Select
                    value={formData.bank_id}
                    onChange={handleBankChange}
                    variant="outlined"
                    sx={{ backgroundColor: "white", borderRadius: "8px", border: "none", boxShadow: "none" }}
                  >
                    {banks.map((bank) => (
                      <MenuItem key={bank.id} value={bank.id} dir="ltr">
                        {bank.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* 
                <FormControl fullWidth sx={{ border: "none", boxShadow: "none" }} dir="ltr">
                    <InputLabel shrink={false} sx={{ 
                        position: 'relative', 
                        transform: 'none',
                        marginBottom: '5px'
                    }}> Select Service </InputLabel>
                    <Select
                        value={formData.service_id}
                        onChange={handleServiceChange}
                        variant="outlined"
                        sx={{ backgroundColor: "white", borderRadius: "8px", border: "none", boxShadow: "none" }}
                    >
                        {service.map((service) => (
                            <MenuItem key={service.id} value={service.id} dir="ltr">
                                {service.service}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl> */}

                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{
                    mt: 2,
                    padding: "10px",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    backgroundColor: "var(--pri-col)",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "var(--pri-col)",
                      color: "white",
                    },
                  }}
                  disabled={!formData.bank_id}
                >
                  Submit
                </Button>
              </form>
            </Box>
          </Modal>
          {/* -------------------------------------- Edit bank account popup -------------------------------------- */}
          <Modal
            open={open2}
            onClose={handleClose2}
          // aria-labelledby="modal-modal-title"
          // aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <EditPayment bankID={bankID} bank={banks} close={handleClose2} render={RenderFun} />
            </Box>
          </Modal>
        </div>
      </Grid>

      <Grid item xs={12} md={12} sx={{ 
        marginInline: { xs: "1rem", md: "40px" }, // Responsive margins
        marginTop: { xs: "2rem", md: "5rem" } 
      }}>
        <TableContainer sx={{ 
          marginTop: "20px",
          overflowX: "auto" // Enable horizontal scroll for table
        }} component={Paper}>
          <p style={{ 
            textAlign: "left", 
            marginLeft: "20px",
            marginTop: "10px",
            fontSize: { xs: "16px", md: "18px" } // Responsive font size
          }}>
            Last Transaction ( Owner )
          </p>

          <Table>
            <TableHead sx={{ backgroundColor: "#F2F4F7" }}>
              <TableRow>
                <TableCell sx={{ 
                  minWidth: { xs: "100px", md: "auto" }, // Minimum width for cells
                  textAlign: "center" 
                }}>Amount</TableCell>
                <TableCell sx={{ 
                  minWidth: { xs: "100px", md: "auto" },
                  textAlign: "center" 
                }}>Date</TableCell>
                <TableCell sx={{ 
                  minWidth: { xs: "100px", md: "auto" },
                  textAlign: "center" 
                }}>Image</TableCell>
                <TableCell sx={{ 
                  minWidth: { xs: "100px", md: "auto" },
                  textAlign: "center" 
                }}>Unit Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ textAlign: "center" }}>{row.amount}</TableCell>
                  <TableCell style={{ textAlign: "center" }}>{row.date}</TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <img src={row.image} style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
                    </div>
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>{row.unit_name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>


      {/*-------------------------------------------------------------- Bank Account ------------------------------------------------------------------*/}
      {/* <h4 style={{ textAlign: "left", marginLeft: "20px" }}>Send Money</h4>
      <div style={styles.card} dir='ltr'>
        <h2 style={styles.cardTitle}>Bank Account</h2>
        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Bank name</label>
            <select style={styles.input} >
              {banks.map((bank) => {
                return (
                  <option key={bank.id}>{bank.name}</option>
                )
              })}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Account number</label>
            <input type="text" placeholder="Write" style={styles.input} />
          </div>
        </div>
        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Receiver name</label>
            <select style={styles.input}>
              <option>Select</option>
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Amount</label>
            <input type="text" placeholder="0.00" style={styles.input} />
          </div>
        </div>
        <button
          style={styles.button}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#914e33")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#b26a48")}
        >
          Send
        </button>
      </div> */}

      <img 
        src="../../assets/Bask 01-04 1.png" 
        style={{ 
          width: { xs: "100px", md: "150px" }, // Smaller on mobile
          height: { xs: "100px", md: "150px" },
          position: "absolute",
          bottom: "0px",
          right: "0px",
          opacity: 0.5 // Make it less prominent
        }} 
      />

    </div>
  );
}

export default Payment;
